import { __assign } from 'tslib';
import * as React from 'react';

// TODO: this SVG component should be replaced by Decorative shape once
// https://invitae.jira.com/browse/WT-19127 is implemented
var CropCornerShape = function (props) {
    return (React.createElement("svg", __assign({ height: "100%", id: "cropCornerShape", width: "100%", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { fill: "#F7E0A6" },
                React.createElement("g", null,
                    React.createElement("g", null,
                        React.createElement("path", { d: "M805 0c121.066 10.301 271.535 57.897 451.408 142.788 57.98 27.364 124.177 70.396 198.592 129.096H805V0z", transform: "translate(0 -2672) translate(0 2672) matrix(-1 0 0 1 1440 0) rotate(180 1130 135.942)" })))))));
};

export { CropCornerShape as default };
//# sourceMappingURL=CropCornerShape.esm.js.map
